import React, { useState, useEffect, useMemo } from 'react'
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';

import Maybe from 'components/__new/common/Maybe';
import { ButtonLoader, Input } from 'components/__new/common/form';
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
import * as walletAction from "store/entities/wallet/action";
import useLoginInfo from 'hooks/useLoginInfo';
import useUrlQueryParams from 'hooks/useUrlQueryParams';
import processParams from 'utils/processParams';
import * as transfersAction from "store/entities/transfers/action"
import ReactSelect from 'react-select';
import { reactSelectStyles } from 'utils/reactSelectStyles';
import useBanks from 'hooks/useBanks';


const BankSingleBeneficiary = ({ toggleBeneficiaryType, initiateBeneficiaryCreation, loading, setIsOpen, transferBeneficiary }) => {
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const { banks, banksLoading } = useBanks(userInfo?.token);
    const {urlQueryParams} = useUrlQueryParams();

    const [form, setForm] = useState({
        accountNumber: "",
        accountName: "",
        bankName: "",
        bankCode: "",
        alias: "",
    });

    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    const [validatedBeneficiary, setValidatedBeneficiary] = useState(null);
    const [validationError, setValidationError] = useState(null);
    
    const { accountValidationLoading, accountValidation, accountValidationError } = useSelector((s) => s.entities.wallet);
    
    const bankAccountInputValid = form.bankCode?.length > 0 && form?.accountNumber?.length === 10
    
    const banksData = useMemo(() => {
        return banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map((singleBank) => ({
            label: singleBank?.bankName || singleBank?.institutionName,
            value: singleBank?.bankCode || singleBank?.institutionCode,
        })) || [];
    }, [banks])
    
    const closeEarnipayTransfersModal = () => {
        toggleBeneficiaryType();
    }
    
    const updateBank = (code) => {
        const bank = banks?.find((bank) => bank?.bankCode === code || bank?.institutionCode === code)
        setForm({...form, bankCode: code, bankName: bank?.bankName || bank?.institutionName, accountNumber: ''});
        setValidatedBeneficiary(null);
    }

    const proceedToTransfer = (e) => {
        e.preventDefault();

        const payload = {
            type: "inter",
            accountNumber: form?.accountNumber?.toString(),
            alias: form?.alias,
            accountName: accountValidation?.accountName,
            bankName: form?.bankName,
            bankCode: accountValidation?.bankCode,
            employerId: userInfo?.employer?._id
        }
        initiateBeneficiaryCreation(payload)
    }

    const disableSubmit = loading || accountValidationLoading || banksLoading || (!form.alias || !form?.bankCode || !form?.accountName)

    const getTransferBeneficiaries = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "keyword");
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");

        setListParams(params);
        dispatch(transfersAction.getTransferBeneficiaries());
    }

    useEffect(() => {
        getTransferBeneficiaries();
        // eslint-disable-next-line
    }, [location]);
    
    useEffect(() => {
        if(bankAccountInputValid) {
            const params = { bankCode: form.bankCode, accountNumber: form.accountNumber };
            
            dispatch(walletAction.validateAccount(userInfo.token, params));
        }
        // eslint-disable-next-line
    }, [form.bankCode, form.accountNumber])
    
    useEffect(() => {
        if (transferBeneficiary?.status === "success") {
            toast.success("Beneficiary created");
            setIsOpen(false);
            getTransferBeneficiaries();
            dispatch(transfersAction.resetCreateTransferBeneficiary())
        }
    }, [transferBeneficiary]);
    
    useEffect(() => {
        if (bankAccountInputValid && accountValidation?.responseMsg?.toLowerCase() === "successful" && accountValidation){
            const accountName = accountValidation?.accountName;
            // const accountNumber = accountValidation?.accountNumber;
            // const accountName = "Abeeb Ayinla";

            setValidationError(null);
            setForm({...form, accountName});
            setValidatedBeneficiary(accountName);
        }
        // eslint-disable-next-line
    }, [accountValidation])
    
    
    useEffect(() => {
        if(accountValidationError !== null) {
            setValidationError("Error Validating Account Details")
        }
        // eslint-disable-next-line
    }, [accountValidationError])
    
    
    useEffect(() => {
        setValidatedBeneficiary(null);
        setValidationError(null);
        // eslint-disable-next-line
    }, [])
    
    
    return (
        <div className='w-full'>
            <form onSubmit={proceedToTransfer}>
                <div className="w-full pt-4 pb-2">
                    
                    <Input
                        type="text"
                        label="Beneficiary Name"
                        value={form?.alias}
                        className="form-input"
                        placeholder="Enter name"
                        onChange={(e) => setForm({...form, alias: e.target.value})}
                    />
                    
                    <div className="form-group relative">
                        <div className="w-full flex items-center justify-between">
                            <label>Bank Name</label>
                        </div>
                        
                        {/* <select className='form-input' disabled={banksLoading} value={form?.bankCode}
                                onChange={(e) => updateBank(e.target.value)}>
                            <option value="">{banksLoading ? "Fetching banks..." : "Select Bank"}</option>
                            {banks?.data?.content?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map(bank => (
                                <option key={bank.bankId || bank?.id} value={bank?.bankCode || bank?.institutionCode}>{bank?.bankName || bank?.institutionName}</option>
                            ))}
                        </select> */}
                        <ReactSelect
                            isDisabled={banksLoading}
                            isLoading={banksLoading}
                            isSearchable
                            name="bankCode"
                            onChange={(selected) => {
                                updateBank(selected.value);
                            }}
                            options={banksData}
                            styles={reactSelectStyles}
                            placeholder={banksLoading ? "Fetching banks..." : "Select Bank"}
                            noOptionsMessage={() => "No Banks Found"}
                        />
                    </div>
                    
                    <div className="form-group relative">
                        <label>Account Number</label>
                        <input
                            type="number"
                            id="prl-input"
                            className="form-input"
                            value={form?.accountNumber}
                            placeholder="Enter Number"
                            onChange={(e) => { setForm({...form, accountNumber: e.target.value}); setValidatedBeneficiary(null); setValidationError(null)}}
                        />
                        
                        <Maybe condition={validationError !== null}>
                            <div className="w-full flex items-center justify-start absolute -bottom-7">
                                <div className='ml-1.5 text-[#dc2626] capitalize text-xs'>
                                    {validationError}
                                </div>
                            </div>
                        </Maybe>
                        
                        <Maybe condition={validatedBeneficiary !== null}>
                            <div className="w-full flex items-center justify-start absolute -bottom-7">
                                <div className="flex items-center text-sm">
                                    <IconCheckCircle width={15} />
                                    <div className='ml-1.5 text-[#153344] capitalize text-xs'>{validatedBeneficiary?.toLowerCase()}</div>
                                </div>
                            </div>
                        </Maybe>
                    </div>
                </div>
                
                <div className="border-t w-full flex items-center justify-end mt-7 pt-5">
                    <button type="button" onClick={closeEarnipayTransfersModal} className="btn btn-transparent-primary mr-3">
                        Cancel
                    </button>
                    
                    <ButtonLoader loading={loading} type="submit" disabled={disableSubmit || accountValidationLoading} className="btn btn-ep-primary">
                        {accountValidationLoading ? "Validating..." : "Add Beneficiary"}
                    </ButtonLoader>
                </div>
            </form>
        </div>
    )
}

export default BankSingleBeneficiary